export const getDefaultValues = (gamePlaylistDetails) => ({
  GameJoinApplicationPlayListLabel: gamePlaylistDetails?.GameJoinApplicationPlayListLabel || '',
  GameJoinApplicationPlayListSubTitle: gamePlaylistDetails?.GameJoinApplicationPlayListSubTitle || '',
  GameJoinApplicationPlayListLogo: gamePlaylistDetails?.GameJoinApplicationPlayListImage || '',
  GameJoinApplicationPlayListBackDrop: gamePlaylistDetails?.GameJoinApplicationPlayListBackDrop || '',
  GameJoinApplicationPlayListBody: gamePlaylistDetails?.GameJoinApplicationPlayListBody || '',
});
